<template>
  <div id="add-screen-module">
    <vue-topprogress
      ref="topProgress"
      style="position: relative;right: 0px;height: 7px;"
    ></vue-topprogress>
    <b-row>
      <div class="modal-body-content-module">
        <div id="planx">
          <!---- new modules interface --->
          <b-row>
            <div class=" module-title">
              <span class="module-title--size">{{ $t('module.slide.title') }}</span>
            </div>
          </b-row>
          <b-row class="header-module-block">
            <b-col sm="8" class="tabs-module-col">
              <div class=" tabs-module">
                <b-tabs
                  active-nav-item-class="font-weight-bold"
                  active-tab-class="font-weight-bold text-success"
                >
                  <b-tab
                    v-for="(tab, index) in allTabs"
                    :key="index"
                    :title="$t('tabs.' + tab)"
                    :class="[{ active: tab === activeModule }]"
                    @click="changeModule(tab)"
                  >
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
            <b-col sm="4" class="search-col">
              <b-input-group class="search-group">
                <b-input-group-append class=" search-icon" v-on:click="searchTitle(true)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5em"
                    height="1.5em"
                    viewBox="0 0 40 40"
                  >
                    <path
                      id="Color"
                      d="M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z"
                      transform="translate(5 6)"
                      fill="#7c7c7c"
                    />
                  </svg>
                </b-input-group-append>
                <b-form-input
                  class="inputSearch"
                  :placeholder="$t('placeholder.search')"
                  id="inputSearch"
                  v-on:keyup.enter="searchTitle(true)"
                  v-model="textToSearch"
                ></b-form-input>
                <div
                  id="close-add-screen-module"
                  class="close-add-screen-module"
                  @click="searchTitle(false)"
                >
                  <i class="icon-close"></i>
                </div>
              </b-input-group>
            </b-col>
          </b-row>
          <!-- empty slide -->
          <b-row class=" d-flex justify-content-between" v-if="activeModule === 'empty'">
            <div class="default-modules screens" v-has-permission="'show_blank_layout_action'">
              <div class="one-disposition">
                <slide-card
                  id="emptyDisposition"
                  :isEditable="false"
                  :isHover="false"
                  :isEmpty="true"
                  :item="empty"
                  :isSelected="selectedIds.includes(emptyScreen.id)"
                  @selected="select(emptyScreen)"
                ></slide-card>
              </div>
            </div>
          </b-row>
          <b-row v-if="activeModule !== 'empty'">
            <div class="default-modules screens">
              <div class="list-modules">
                <div
                  class="one-disposition"
                  v-for="(item, index) in getComputedList"
                  :key="'screen-s-' + item.id"
                >
                  <slide-card
                    :have-screen="haveScreen(item)"
                    :Shot="screenShot(item)"
                    :isHover="true"
                    :id="item.id"
                    :item="item"
                    :ModalSegment="true"
                    :title="item.title"
                    :itemsegment="item"
                    :isSelected="selectedIds.includes(item.id)"
                    @selected="select(item)"
                    @showSelect="showSelect($event, item, index)"
                    :class="{ 'fix-height': activeModule === 'images' }"
                    :isActiveModule="activeModule"
                  ></slide-card>
                </div>
              </div>
              <!--<infinite-loading-->
              <!--style="display: none"-->
              <!--@infinite="loadMore()"-->
              <!--:distance="10"-->
              <!--:direction="'bottom'"-->
              <!--spinner="bubbles"-->
              <!--:identifier="'add-slide'"-->
              <!--id="custom-infinite"-->
              <!--&gt;-->
              <!--<div slot="no-more" v-show="noMoreMedias"></div>-->
              <!--<div slot="no-results" v-show="noResultMedias"></div>-->
              <!--</infinite-loading>-->
            </div>
          </b-row>
          <b-row>
            <div class=" timeline-title">
              <span>{{ $t('module.timeline.title') }}</span>
            </div>
          </b-row>
          <b-row>
            <div class="timeline-modules">
              <div class="col-xs-1">
                <div
                  class="button-navigation button-navigation__left"
                  :class="[{ active: hasScrollSlides }]"
                >
                  <button
                    id="button-navigation-left"
                    class="  button-navigation--left btn btn-sm pl-1 pr-1"
                    :disabled="!hasScrollSlides"
                    @click="dragSlide($event, -1, 'add-screen-module')"
                  >
                    <div class="icon-navigation-left">
                      <svg viewBox="0 0 32 32" width="20px" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#939ea7">
                          <path
                            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
                          />
                          <path
                            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
                          />
                        </g>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>

              <b-col sm="11" class="div-draggable-margin">
                <div id="div-draggable" class="slides-panel row">
                  <VuePerfectScrollbar
                    id="ps-slide-wrapper"
                    class="scroll-area"
                    ref="ps"
                    :use-both-wheel-axes="true"
                  >
                    <div class="row__inner" @mousewheel="scrollHorizontally">
                      <draggable
                        id="draggable-wrapper"
                        v-model="list"
                        @end="reorder"
                        @start="getList"
                        :move="dragSlide"
                      >
                        <div
                          v-for="(slide, index) in ListSelected"
                          class="card-wrapper"
                          :class="{ extended: slide.isExtended }"
                          :key="'list-screen-' + index"
                          :data-uid="slide.uid"
                        >
                          <span class="counter-slides">
                            {{ index + 1 }}
                          </span>
                          <panel-card
                            :index="index"
                            :slide="slide"
                            :isSelected="slide.uid === currentSegment.uid"
                            :removable="ListSelected.length > 1"
                            :showVideoIntro="{}"
                            :isSegmentCard="false"
                            :isModuleList="true"
                            :isScreenList="true"
                            @remove-segment="select(slide)"
                          >
                          </panel-card>
                        </div>
                      </draggable>
                    </div>
                  </VuePerfectScrollbar>
                </div>
              </b-col>

              <div class="col-xs-1">
                <div
                  class="button-navigation button-navigation__right"
                  :class="[{ active: hasScrollSlides }]"
                >
                  <button
                    id="button-navigation-right"
                    class=" button-navigation--right btn btn-sm pl-1 pr-1"
                    :disabled="!hasScrollSlides"
                    @click="dragSlide($event, 1, 'add-screen-module')"
                  >
                    <div class="icon-navigation-right">
                      <svg viewBox="0 0 32 32" width="20px" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#939ea7">
                          <path
                            d="M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
                          />
                          <path
                            d="M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
                          />
                        </g>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </b-row>
          <b-row class="position-buttons">
            <button
              :class="['btn outline-primary position-buttons__back']"
              v-on:click="cancel()"
              id="btn-back"
            >
              <i :class="['fa fa-arrow-left']"></i> {{ $t('button.back') }}
            </button>
            <button
              :class="['btn btn-primary position-buttons__confirm']"
              v-on:click="confirm()"
              :disabled="disabledConfirmButton"
            >
              <i :class="['fa fa-check']"></i> {{ $t('button.confirm') }}
            </button>
          </b-row>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import SlideCard from './Modal/SlideCard';
import mixin from '../mixins/Mixin.js';
import { Carousel, Slide } from 'vue-carousel';
import mixinGrapesHelpers from '../mixins/GrapesMixinHelpers';
import SegmentList from './Modal/SegmentList.vue';
import { vueTopprogress } from 'vue-top-progress';
import HasPermission from '../core/directives/HasPermission.js';
import * as durationHelper from '../helpers/duration-handler';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import InfiniteLoading from 'vue-infinite-loading';
import { bus } from '../main';
import draggable from 'vuedraggable';
import mixinEditors from '../mixins/GrapesMixinEditors';
import mixinTranslate from '../mixins/GrapesMixinTranslate';
import GrapesMixinPanels from '../mixins/GrapesMixinPanels';
import PanelCard from './Panel/PanelCard';

const lowercaseKeys = require('lowercase-keys');
export default {
  name: 'AddScreen',
  mixins: [mixin, mixinGrapesHelpers, mixinEditors, mixinTranslate, GrapesMixinPanels],
  directives: {
    HasPermission,
  },
  data() {
    return {
      options: [],
      ligneTemplate: [],
      clicksOut: true,
      showCollapse: false,
      navparam: true,
      selectedTab: '',
      infiniteState: null,
      selectedIds: [],
      selecteIdSegment: [],

      titleTemplate: this.$t('template.new_template'),
      total: 0,
      hideCancelButton: true,
      disabledConfirmButton: true,
      duration: 59,
      isActiveModule: false,
      activeModule: 'models',
      all_videos: [],
      all_images: [],
      textToSearch: '',
      tabs: ['models', 'recents', 'images', 'empty'],
      scrollInterval: null,
      list: [],
      lists: [],
      segmentKey: 0,
      showScroll: false,
      isExtendedSlides: false,
      oldImages: false,
      titleSegment: '',
        tabsArray:[]
    };
  },
  components: {
    vueTopprogress,
    SlideCard,
    Carousel,
    Slide,
    SegmentList,
    VuePerfectScrollbar,
    InfiniteLoading,
    draggable,
    PanelCard,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  watch: {
    isLoading(isLoading) {
      if (this.infiniteState) {
        if (this.isEndReached('Disposition') || this.isEndReached('Screen')) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    isLoadingMedias(isLoading) {
      this.callLoadMedias(isLoading);
    },

    dispositions(dispositions) {
      if (dispositions.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.reloadList();
        }
        this.infiniteState.reset();
      }
    },
    AllScreens(AllScreens) {
      if (AllScreens.length === 0 && this.infiniteState) {
        if (!this.isLoading) {
          this.reloadList();
        }
        this.infiniteState.reset();
      }
    },
    getAllMedias(medias) {
      if (medias[this.activeModule].length === 0 && this.infiniteState) {
        if (!this.isLoadingMedias) {
          this.loadMore();
        }
        this.infiniteState.reset();
      }
    },
    all: {
      handler(all) {
        all.forEach((el, index) => {
          this.lists[index] = this.getScreens(el);
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      screens: 'slides/getAllScreens',
      AllScreens: 'slides/getAllScreens',
      currentSlide: 'slides/getCurrent',
      dispositions: 'slides/getAllDispositions',
      all: 'segments/getSelectedSegments',
      segments: 'segments/getAllSegments',
      SegmentsFiltredByTitle: 'segment/getFilterSegments',
      currentPage: 'segments/getCurrentPage',
      isLoading: 'slides/getLoading',
      isLoadingMedias: 'medias/getLoading',
      isEndReached: 'slides/getEndReached',
      isEndReachedMedias: 'medias/getEndReachedMedias',
      selected: 'slides/getSelected',
      currentSegment: 'segments/getCurrent',
      isSelected: 'slides/isSelected',
      firstSelectedSegment: 'segments/getLastSegmentById',
      showIconSave: 'common/getShowIconSave',
      paramsClient: 'getParamsClients',
      hasPermission: 'hasPermission',
      totalDurationSegments: 'segments/getAllSegmentsDuration',
      template: 'slides/getTemplate',
      nb_videos: 'medias/getNbVideos',
      getAllMedias: 'medias/getAllMedias',
      nb_slides: 'slides/getNbSlides',
      lastUpdatedSegment: 'segments/getLastUpdatedSegmentById',
      ListSelected: 'slides/getListSelected',
      nbrCall: 'segments/getNbrCall',
      firstSelectedSlide: 'slides/getLastSlideById',
      getAssetManager: 'grapes/getAssetManager',
      getPermissions:"getPermissions"
    }),
      allTabs() {
          for (let i = 0; i < this.tabs.length; i++) {
              if (
                  this.getPermissions['show_' + this.tabs[i] + '_part_action'] ||
                  this.tabs[i] === 'empty'
              ) {
                  this.tabsArray.push(this.tabs[i]);
                  if (this.tabsArray.length > 0) {
                      this.activeModule = this.tabsArray[0];
                  }
              }
          }
          return this.tabsArray;
      },
    hasScrollSlides() {
      if (this.ListSelected.length > 0) {
        let count = this.ListSelected.length;

        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector(
          '#add-screen-module .timeline-modules .div-draggable-margin .slides-panel .card-wrapper',
        );
        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector(
          '#add-screen-module .timeline-modules .div-draggable-margin .slides-panel',
        );
        if (panel) {
          panelWidth = panel.offsetWidth;
        }

        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },

    stateTitle() {
      var state = this.titleTemplate.length >= 1 ? true : false;
      if (state) return null;
      else return state;
    },
    stateLigne() {
      var state = this.ligneTemplate.length >= 1 ? true : false;
      if (state) return null;
      else return state;
    },
    stateDuration() {
      if (
        this.durationTemplate === '00:00:00' ||
        this.durationTemplate === '' ||
        this.durationTemplate === '00:00'
      )
        return false;
      else return null;
    },
    durationTemplate: {
      get: function() {
        let value = this.duration;
        let hours = Math.floor(value / 3600);
        value %= 3600;
        let minutes = Math.floor(value / 60);
        let seconds = value % 60;
        let addZero = v => (v < 10 ? '0' + v : v);
        let t = [];

        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));

        return t.join(':');
      },
      set: function(value) {
        this.duration = value
          .split(':')
          .reverse()
          .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
      },
    },
    empty() {
      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: durationHelper.totalSegmentDuration(),
        },
        styles: '',
        title: this.$t('disposition.empty'),
        transition: {
          in: '',
          out: '',
        },
        type: 'Disposition',
        screenShot:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0,
      };
      return disposition;
    },

    emptyScreen() {
            let customTitle ="";
      if (this.selected.length){
customTitle =         this.$t('screens.screen') +
        parseInt(this.selected.filter(s => s.options.oldType === 'empty').length + 1);

      }
      if ((this.$route.name === 'add' || this.$route.name === 'edit') && this.currentSegment.screens.length) {
        customTitle =
          this.$t('screens.screen') +
          parseInt(
            this.currentSegment.screens.filter(s => s.options.oldType === 'empty').length + 1,
          );
      }

      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: durationHelper.totalSegmentDuration(),
          oldType: 'empty',
        },
        styles: '',
        title: customTitle,
        transition: {
          in: '',
          out: '',
        },
        type: 'Disposition',
        screenShot:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0,
      };
      return disposition;
    },
    getComputedList() {
      if (this.activeModule === 'models'  && this.hasPermission('show_models_part_action')) {
        this.reloadList('models');
        return this.dispositions;
      } else if (this.activeModule === 'recents'  && this.hasPermission('show_recents_part_action')) {
        this.reloadList('recents');
        return this.AllScreens;
      } else {
        this.reloadListMedias();
        if(  this.hasPermission('show_images_part_action')){
            if (this.oldImages) {
                let allOldImages = [];
                let i = 0;
                if(this.getAssetManager) {
                  this.getAssetManager.map(data => {
                      i++;
                      allOldImages.push({ id: i, title: 'image-' + i, lien: data });
                  });
                }
                return allOldImages;
            } else {
                this.all_images = this.getAllMedias(this.activeModule);
                return this.getAllImages();
            }
        }
      }
    },
    getAllImages() {
      let allImage = [];
      this.getAllMedias(this.activeModule).map(data => {
        allImage.push(lowercaseKeys(data));
      });
      return allImage;
    },
    noMoreMedias() {
      if (this.activeModule === 'models') {
        return this.isEndReached('Disposition');
      } else if (this.activeModule === 'recents') {
        return this.isEndReached('Screen');
      } else {
        return this.isEndReachedMedias(this.activeModule);
      }
    },
    noResultMedias() {
      if (this.activeModule === 'models') {
        return this.dispositions.length === 0;
      } else if (this.activeModule === 'recents') {
        return this.AllScreens.length === 0;
      } else {
        return this.getAllMedias(this.activeModule).length === 0;
      }
    },
    hasImagesModules() {
      let found = false;
      if (
        this.paramsClient.display_default_blocks ||
        Object.keys(this.paramsClient.display_default_blocks).length > 0
      ) {
        this.paramsClient.display_default_blocks.map(block => {
          for (let i = 0; i < block.blocks.length; i++) {
            if (block.blocks[i] === 'image_media') {
              found = true;
            }
          }
        });
      }
      return found;
    },
  },
  methods: {
    ...mapActions('segments', [
      'getSegments',
      'paginatesegment',
      'selectSegment',
      'setCurrentSegment',
      'removeLastSegmentById',
      'updateSegment',
      'setTitle',
      'setSegments',
      'setNbrCall',
      'updateSlideInsideSegment',
      'selectMedias',
      'reorderSegments',
      'reorderSlidesInsideSegment',
      'appendSlideToSegment',
      'removeLastSlideFromSegmentById',
      'appendImageToSegment',
    ]),
    ...mapActions('common', ['setShowIconSave']),
    ...mapActions('slides', [
      'selectImage',
      'paginate',
      'selectSlide',
      'setCurrentSlide',
      'removeLastSlideById',
      'updateSlide',
      'fetch',
      'resetPage',
      'setTemplate',
      'setDispositions',
      'pushListSelected',
      'resetListSelected',
      'removeFromListSelected',
      'resetSelect',
      'changeTitleInSelected',
    ]),
    ...mapActions(['setRoute']),
    ...mapActions('medias', [
      'reloadVideoList',
      'reloadImageList',
      'resetPageVideos',
      'setTitleMedias',
      'setMedias',
    ]),
    setActiveScrollButtons() {
      if (this.ListSelected.length > 0) {
        let count = this.ListSelected.length;
        let panelWidth = 0;
        let widthSlides = 0;
        let cardWrapper = document.querySelector(
          '#add-screen-module .timeline-modules .div-draggable-margin .slides-panel .card-wrapper',
        );

        if (cardWrapper) {
          widthSlides = count * cardWrapper.clientWidth;
          if (this.isExtendedSlides) {
            let extendedPanel = document.querySelector('.inner-slides-wrapper.extended');
            widthSlides += extendedPanel.offsetWidth;
          }
        }
        let panel = document.querySelector(
          '#add-screen-module .timeline-modules .div-draggable-margin .slides-panel',
        );
        if (panel) {
          panelWidth = panel.offsetWidth;
        }
        if (widthSlides >= panelWidth) {
          this.showScroll = true;
        } else {
          this.showScroll = false;
        }
        this.$root.$emit('showScroll', this.showScroll);
        return this.showScroll;
      }
    },
    reloadList(module) {
      let self = this;
      let listElm = document.querySelector('#add-screen-module .default-modules.screens');
      if (module === 'models') {
        if (self.nb_slides === self.dispositions.length) {
          return;
        }
      } else {
        if (self.nb_slides === self.AllScreens.length) {
          return;
        }
      }

      if (listElm) {
        listElm.onscroll = function() {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            self.setHiddenScroll(module);
          }
        };
      }
    },
    reloadListMedias() {
      let self = this;
      let listElm = document.querySelector('#add-screen-module .default-modules.screens');
      if (self.nb_videos === self.getAllMedias(self.activeModule).length) {
        return;
      }
      if (listElm) {
        listElm.onscroll = function() {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            self.setHiddenScroll();
          }
        };
      }
    },

    setHiddenScroll(module) {
      let self = this;
      if (module === 'models' &&   self.hasPermission('show_models_part_action')) {
        if (self.dispositions.length < self.nb_slides || !self.isEndReached(module)) {
          self.paginate('Disposition');
        }
      } else if (module === 'recents'&&  self.hasPermission('show_recents_part_action')) {
        if (self.AllScreens.length < self.nb_slides || !self.isEndReached(module)) {
          self.paginate('Screen');
        }
      } else {
        if (!self.oldImages &&   self.hasPermission('show_images_part_action')) {
          if (
            self.getAllMedias(self.activeModule).length < self.nb_videos ||
            !self.isEndReachedMedias(self.activeModule)
          ) {
            if(self.hasPermission('show_images_part_action')) self.reloadImageList();
          }
        }
      }
    },
    callLoadMedias(isLoading) {
      if (this.infiniteState) {
        if (this.isEndReachedMedias(this.activeModule)) {
          this.infiniteState.complete();
        } else if (!isLoading) {
          this.infiniteState.loaded();
        }
      }
    },
    haveScreen(item) {
      if (item.screens) {
        return false; //item.screens.length > 1;
      }
    },
    screenShot(item) {
      if (this.activeModule === 'models' || this.activeModule === 'recents') {
        if (item.screenShot) {
          return item.screenShot ? item.screenShot : '';
        }
      } else {
        if (this.activeModule === 'images') {
          if (!this.oldImages) {
            return this.getThumbnailUrl(item, 'fit', 500)
              ? this.getThumbnailUrl(item, 'fit', 500)
              : '';
          } else {
            item.lien ? item.lien : '';
          }
        } else {
          return item.logo ? item.logo : '';
        }
      }
    },
    loadMore($state) {
      //TODO  fix infiniteState
      if (!this.infiniteState) {
        this.infiniteState = $state;
      }
      if (this.activeModule === 'models') {
        if (this.isEndReached('Disposition') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else if (this.activeModule === 'recents') {
        if (this.isEndReached('Screen') && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      } else {
        if (this.isEndReachedMedias(this.activeModule) && this.infiniteState) {
          this.infiniteState.complete();
          return;
        }
      }
      if ($state) {
        if (this.activeModule === 'models' &&   this.hasPermission('show_models_part_action') ) {
          this.paginate('Disposition');
        } else if (this.activeModule === 'recents'  &&   this.hasPermission('show_recents_part_action')) {
          this.paginate('Screen');
        } else {
          if (!this.oldImages  &&   this.hasPermission('show_images_part_action')) {
            this.reloadImageList();
          }
        }
      }
    },
    changeModule(module) {
      this.activeModule = module;
      this.isActiveModule = true;
      document.querySelector('.search-col').style.display = 'block';

      if (document.querySelector('.infinite-loading-container')) {
        //document.querySelector('.infinite-loading-container').style.display = 'block';
      }
      // this.searchTitle();
      if (module === 'models') {
        if (this.dispositions.length === 0) {
          this.resetPage('Disposition');
          this.paginate('Disposition');
        }
      } else if (module === 'recents') {
        if (this.AllScreens.length === 0) {
          this.resetPage('Screen');
          this.paginate('Screen');
        }
      } else if (module !== 'empty' && module === 'images') {
        //this.loadMore();
        if (this.all_images.length === 0) {
          this.setMedias('images', []);
          this.resetPageVideos('images');
          if (!this.oldImages) {
            this.reloadImageList();
          } else {
            if(document.querySelector('.infinite-loading-container')) {
              document.querySelector('.infinite-loading-container').style.visibility = 'hidden';
            }
            document.querySelector('.search-col').style.display = 'none';
          }
        }
    }
    
      bus.$emit('displaycreenShot', module);
      if(this.textToSearch) {
        this.searchTitle(true);
      }
    },
    optionsLine() {
      if (this.paramsClient.default_line) {
        this.options = this.paramsClient.default_line;
        this.ligneTemplate = this.options[0].value;
      }
    },

    showSegmentModal() {
      // this.$router.push({ name: 'segment' });
      this.$router.push({ name: 'EditSegment' });
      this.setRoute('segment');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerHTML =
          "<span style='font-family:RobotoUep!important;'>" +
          this.$t('template.save_and_exit') +
          '</span>';
      }
      this.cancel();
      eventHub.$emit('resetModalSegmentList');
      // this.$root.$emit('bv::show::modal', 'segment-list-modal', '#btnShow');
    },
    // loadMore() {
    //   this.isShown = true;
    // },
    showTab(tab) {
      this.selectedTab = tab;
    },
    select(item) {
      let limitAdd = this.getNbSreenSegment();
      let nb_screeen = this.permission.nb_screen_segment;
      let selected = JSON.parse(JSON.stringify(item));

      /******************  ROUTE segment    ***************/
      if (this.$route.name === 'segment') {
        //remove Last Slide By Id

        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
          this.removeLastSlideById(selected.id);
          this.removeFromListSelected(selected.id);
        } else {
          // Type   models &&  recents
          this.selectedIds.push(selected.id);
          this.disabledConfirmButton = false;
          if (
            this.activeModule === 'models' ||
            this.activeModule === 'recents' ||
            this.activeModule === 'empty'
          ) {
            this.selectSlide(selected);
            this.pushListSelected(selected);
          } else {
            let src = this.getThumbnailUrl(selected, 'fit', 500);
            let duration = durationHelper.totalSegmentDuration();
            let option = {
              duration: durationHelper.totalSegmentDuration(),
            };
            let slide = {
              id: selected.id,
              src: src,
              title: selected.phototitle,
              logo: selected.logo,
              options: option,
              duration: duration,
            };
            if (!this.oldImages) {
              slide.src = this.getThumbnailUrl(selected, 'fit', 500);
              slide.title = selected.phototitle;
            } else {
              if (selected.lien.indexOf('/mini') > -1) {
                slide.src = selected.lien.replace('/mini', '');
              } else {
                slide.src = selected.lien;
              }

              slide.title = selected.title;
            }
            this.selectImage({ selected: slide, type: this.activeModule });
          }
        }
      } else {
        /******************  ROUTE add  ( program )    ***************/
        // remove Last Slide From Segment By Id
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
          this.removeLastSlideFromSegmentById(selected.id);
          this.removeFromListSelected(selected.id);
          this.dragSlide(event, -1, 'add-screen-module');
        } else {
          this.selectedIds.push(selected.id);
          this.disabledConfirmButton = false;
          if (
            this.activeModule === 'models' ||
            this.activeModule === 'recents' ||
            this.activeModule === 'empty'
          ) {
            //this.selectSlide(selected);
            this.appendSlideToSegment(selected);
            this.pushListSelected(selected);
          }
          // Type   Image
          else {
            let duration = durationHelper.totalSegmentDuration();
            let option = {
              duration: durationHelper.totalSegmentDuration(),
            };
            let slide = {
              id: selected.id,
              src: src,
              title: selected.phototitle,
              logo: selected.logo,
              options: option,
              duration: duration,
            };
            if (!this.oldImages) {
              slide.src = this.getThumbnailUrl(selected, 'fit', 500);
              slide.title = selected.phototitle;
            } else {
              if (selected.lien.indexOf('/mini') > -1) {
                slide.src = selected.lien.replace('/mini', '');
              } else {
                slide.src = selected.lien;
              }
              slide.title = selected.title;
            }
            // this.selectSlide(slide);
            this.appendImageToSegment({ selected: slide, type: this.activeModule });
            this.pushListSelected(slide);
          }
          this.dragSlide(event, 1, 'add-screen-module');
        }
      }
      // disabledConfirmButton
      if (this.selectedIds.length < 1) {
        this.disabledConfirmButton = true;
      }
    },
    getThumbnailUrl(selectedSegment, type, size) {
      const fileHash = selectedSegment.filehash;
      return process.env.API_GO_HOST + 'thumbnails/' + type + '/' + size + '/' + fileHash;
    },
    selectAddedSlide(segment, slide) {
      if (segment.uid !== this.currentSegment.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      // editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          //Set Current Screen
          this.setCurrentSlide(slide);
          //Set Current Segment by Screen
          this.setCurrentSegment(segment);
          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },

    confirm() {
      const editor = grapesjsEMP.editors[0];
      var self = this;
      this.selected.map(s => (this.total += s.options.duration));

      // Segment
      const segment = {
        screensToSubmit: this.selected,
        duration: self.totalDurationScreens,
        uid: Math.floor(new Date().valueOf() * Math.random()),
      };
      // this.selectMedias({ selected: slide, type: this.activeModule });
      let newSegment = Object.assign({}, segment, this.currentSegment);
      self.setCurrentSegment(newSegment);
      const psElement = document.getElementById('ps-slide-wrapper');
      try {
        const DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
      } catch (e) {}

      if (this.$route.name === 'segment') {
        // nb_screen_segment = 1 , on doit afficher le titre de segment dans le card et dans le panel
        let nb_screeen_param = this.paramsClient.nb_screen_segment;
        /*if (parseInt(nb_screeen_param) === 1) {
          this.changeTitleInSelected(
            this.titleSegment !== '' ? this.titleSegment : this.$t('panels.newSegment'),
          );
          this.setCurrentSlide(this.selectedIds[0]);
        }*/
        this.FirstSlide();
      } else if (this.selectedIds.length > 0) {
        this.selectAddedSlide(
          this.lastUpdatedSegment,
          this.lastUpdatedSegment.screens[this.lastUpdatedSegment.screens.length - 1],
        );
      }

      this.selectedIds = [];
      eventHub.$emit('setShowAddScreen', false);

      self.setNbrCall();
      //ButtonDisabled for the next call
      this.disabledConfirmButton = true;
      ///new
      this.setNoAutoplayVideo(editor);
      let videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(player => {
        this.setPausedVideo(player);
      });

      //reset List in panel
      this.resetListSelected();
      this.updateCanvasDimensions();
      setTimeout(() => {
        if (
          this.paramsClient.display_default_blocks &&
          Object.keys(this.paramsClient.display_default_blocks).length > 0
        ) {
          const blocks = document.querySelector(
            '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
          );
          if (blocks) {
            blocks.click();
          }
        }
      }, 100);
    },

    FirstSlide() {
      const lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles'),
      };
      this.updateSlide(lastSlide);

      this.generateSlideThmbnail(lastSlide.uid);
      const slide = this.firstSelectedSlide(this.selectedIds[0]);
      this.setCurrentSlide(slide);
      this.$root.$emit('updateCanvasContent');
    },

    cancel() {
      this.selectedIds.forEach(id => {
        // remove select slide   ( add new segment  )
        this.removeLastSlideById(id);
        // remove select slide  ( panelpage : add screens to segment )
        this.removeLastSlideFromSegmentById(id);
      });
      this.selectedIds = [];
      this.resetListSelected();
      if (this.$route.params.type === 'NewSegment' && this.nbrCall === 1) {
        this.$router.push({ name: 'AddSegment' });
      }
      eventHub.$emit('setShowAddScreen', false);
    },

    searchTitle(x) {
      var title = '';
      if (x) {
        title = this.textToSearch;
        this.setTitle(title);
        this.setTitleMedias(title);
        if (this.activeModule === 'models'  &&   this.hasPermission('show_models_part_action')) {
          this.setDispositions([]);
          this.resetPage('Disposition');
          this.paginate('Disposition');
        } else if (this.activeModule === 'recents' && this.hasPermission('show_recents_part_action')) {
          this.setDispositions([]);
          this.resetPage('Screen');
          this.paginate('Screen');
        } else {
            if(this.hasPermission('show_images_part_action')){
                this.setMedias({ type: this.activeModule, medias: [] });
                this.resetPageVideos(this.activeModule);
                if (!this.oldImages) {
                    this.reloadImageList();
                }
            }
        }
      } else {
        this.textToSearch = '';
        this.activeModule =this.tabsArray[0];
        this.setTitle(title);
        this.setTitleMedias(title);
        if( this.hasPermission('show_models_part_action')){
            this.setDispositions([]);
            this.resetPage('Disposition');
            this.paginate('Disposition');
        }
        if(this.hasPermission('show_recents_part_action')){
            this.setDispositions([]);
            this.resetPage('Screen');
            this.paginate('Screen');
        }
      if(this.hasPermission('show_images_part_action')){
          this.setMedias({ type: 'images', medias: [] });
          this.resetPageVideos('images');
          this.reloadVideoList();
          if (!this.oldImages) {
              this.reloadImageList();
          }
      }
     }
    },

    setButtonCancel(cancel) {
      this.hideCancelButton = cancel;
    },

    getScreens(segment) {
      return segment.screens.filter(s => {
        return (
          s.type.toLowerCase().indexOf('generic') + s.type.toLowerCase().indexOf('blank') === -2
        );
      });
    },
    removeSmoothing(event) {
      if (event) {
        this.$refs.ps.$el.style['scroll-behavior'] = 'auto';
      }
    },
    reorder(event) {
      this.reorderSegments(event);
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    reorderSlides(event, index) {
      this.reorderSlidesInsideSegment({ event, index });
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
  },
  async mounted() {
    //this.reloadVideoList();
    let self = this;
    if (
      this.paramsClient.display_default_blocks !== null ||
      Object.keys(this.paramsClient.display_default_blocks).length > 0
    ) {
      let blocks = this.paramsClient.display_default_blocks.map(block => {
        return block.blocks;
      });
      blocks.forEach((item, index) => {
        for (let i = 0; i < item.length; i++) {
          if (item[i].indexOf('image') > -1) {
            self.oldImages = true;
          }
        }
      });
    }
    if (!self.oldImages && this.hasPermission('show_images_part_action')) {
      this.reloadImageList();
    }
    this.titleSegment = this.$t('panels.newSegment');

    this.$root.$emit('displaycreenShot', this.activeModule);
    this.$root.$on('updateScrollInterval', obj => {
      this.dragSlide(obj.event, obj.position, 'add-screen-module');
    });
    this.optionsLine();
    document
      .querySelector('.timeline-modules #ps-slide-wrapper')
      .addEventListener('mouseover', this.removeSmoothing);
    eventHub.$on('setShowAddScreen', val => {
      this.selecteIdSegment = [];
      this.hideCancelButton = !val;
      this.disabledConfirmButton = val;
      this.activeModule = this.tabsArray[0];
      this.setActiveScrollButtons();
    });
  },
  created() {
    let self = this;
    eventHub.$on('stopProgress', val => {
      self.$refs.topProgress.done();
    });
    eventHub.$on('saveSelect', this.select);
    eventHub.$on('hideCancelButton', this.setButtonCancel);
  },
};
</script>

<style lang="scss">
$primar-color: #2196f3;
#add-screen-module {
  .modal-body-content-module {
    padding: 20px 30px;
    #collapse-1 {
      background-color: rgba(124, 124, 124, 0.38);
    }
    #collapse-2 {
      background-color: rgba(124, 124, 124, 0.38);
    }

    .top-progress .peg {
      display: none !important;
    }

    #fa-plus {
      color: #2196f3;
      cursor: pointer;
    }

    #editor .form-control .input-time {
      color: #2196f3;
    }
    #emptyDisposition {
      border-style: solid;
      border-radius: 6px;
      border-color: #2196f3;
      text-align: center;
      .title-screen {
        width: 100%;
        height: 100%;
        position: absolute;
        font-weight: bold;
        text-align: center;
        padding: 0.5em;
        background: #ffffff;
        /* height: 8em; */
        /* padding-top: 50px; */
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        vertical-align: middle;
        &__span {
          color: #2196f3;
          text-align: center;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 14px;
          .fa.fa-file-o {
            padding: 0 0.3em;
            font-size: 2.2em;
          }
        }
      }
      &:hover {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
        .edit-title-btn {
          opacity: 1 !important;
          visibility: visible !important;
          background: rgba(26, 147, 240, 0.6);
        }
        .title-screen {
          background: rgba(26, 147, 240, 0.6);
          &__span {
            color: #ffffff;
          }
        }
      }
      &.selected {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
        .buttons-container {
          opacity: 0;
          visibility: hidden;
        }
        &:before {
          background: rgba(26, 147, 240, 0.6);
        }
        .title-screen {
          background: none;
        }
        .tick-img {
          display: block;
        }
        .title-screen__span {
          color: #ffffff;
        }
      }
    }

    #content-plan2 {
      margin-left: 10%;
      margin-right: 10%;
      padding-top: 10%;
    }
    .modal-body {
      padding: 0;
    }
    .slide {
      margin: 5px !important;
      &.fix-height {
        .img-fluid {
          height: 100% !important;
        }
      }
    }
    .VueCarousel-navigation .VueCarousel-navigation-button :focus {
      outline: none !important;
    }
    .section-screen,
    .section-disposition {
      margin: 1em 0 1em 0;
      &__title {
        line-height: 0.5;
        text-align: left;
        width: 100%;
        .add-segment {
          padding: 0;
        }
      }
      &__title span {
        display: inline-block;
        position: relative;
        /*text-transform: uppercase;*/
        font-size: 1.2em;
        font-weight: 400;
        width: 100%;
      }
      //&__title span:before,
      &__title span:after {
        content: '';
        position: absolute;
        height: 5px;
        border-bottom: 1px solid #f0f0f0;
        /*top: 0;*/
        width: 100%;
        min-width: 100%;
      }
      &.title-border-size span:after {
        width: 95%;
        min-width: 95%;
      }
      /*&__title span:before {*/
      /*right: 100%;*/
      /*margin-right: 15px;*/
      /*}*/
      &__title span:after {
        // left: 100%;
        margin-left: 10px;
      }
    }
    //0 left 1 center
    .VueCarousel-slide {
      flex: 0 0 25%;
    }
    #slide-list-modal {
      color: #707070;
      &___BV_modal_header_ {
        background-color: $primar-color;
        color: #ffffff;
        border-radius: 0;
        .title {
          margin-bottom: 0;
        }
      }
      &___BV_modal_content_ {
        border-radius: 0;
      }
      &___BV_modal_footer_ {
        .btn-primary {
          background-color: $primar-color;
          border-color: $primar-color;
          border-radius: 0.1rem;
        }
        .btn-link {
          &:hover,
          &:focus {
            text-decoration: none;
          }
        }
      }
      .modal-dialog.modal-xl {
        max-width: 1000px !important;
      }
    }

    .VueCarousel-navigation-button:focus {
      outline: none !important;
    }
    .VueCarousel-slide {
      visibility: visible;
      flex-basis: 100%;
      width: 100%;
    }
    .displayButton {
      display: none;
    }
    .buttons-position {
      padding-right: 0 !important;
      padding-left: 0;
      position: relative;
      top: 76px;
      display: flex;
      justify-content: flex-end;
    }
    .buttons-modules {
      display: flex;
      flex-direction: column;
      .button-module {
        margin: 5px 0 !important;
        border: none !important;
        border-color: transparent !important;
        color: #acacac !important;
        width: 5em;
        height: 3em;
        border-radius: 0;
        border-top-left-radius: 15px !important;
        border-bottom-left-radius: 15px !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        .models,
        .images,
        .videos {
          display: flex;
          width: 2em;
        }
        &:hover {
          color: white !important;
          background: linear-gradient(300deg, rgba(255, 0, 0, 0) 40%, #2196f3),
            linear-gradient(235deg, rgba(0, 0, 255, 0) 40%, #2196f3) !important;
        }
        &.selected {
          color: white !important;
          border: 1px solid $primar-color !important;
          background: linear-gradient(300deg, rgba(255, 0, 0, 0) 40%, #2196f3),
            linear-gradient(235deg, rgba(0, 0, 255, 0) 40%, #2196f3);
          border-right: none !important;
          .models,
          .images,
          .videos {
            svg {
              fill: white;
            }
          }
        }
      }
    }
    .position-add_model {
      display: flex;
      justify-content: flex-end;
      padding-right: 2em;
      align-items: center;
    }
    .video-list {
      /*position: absolute;*/
      padding: 1em;
    }
    .card-modules {
      border: 1px solid $primar-color;
      border-radius: 20px;
      padding: 1em;
      height: 640px; //605px;
      /* position: relative; */
      max-height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    /*.slides-carousel {*/
    /*display: flex;*/
    /*flex-direction: row;*/
    /*!* width: 100%; *!*/
    /*justify-content: space-between;*/
    /*height: 100%;*/
    /*!*overflow: auto;*!*/
    /*}*/
    .position-buttons {
      position: absolute;
      right: 3em;
      display: flex;
      justify-content: flex-end;
      /* margin-top: 2em; */
      bottom: 1em;
      &__cancel,
      &__finish,
      &__next,
      &__confirm {
        margin: 0 5px !important;
        padding: 0.375rem 2em !important;
      }
    }
    .add-model-button {
      border-radius: 20px !important;
      padding: 0 1em !important;
      font-size: 0.9em !important;
      height: 2em;
    }
    #triangle {
      height: 175px;
      position: absolute;
      top: 180px;
      width: 98%;
      #collapse-1 {
        height: 100%;
        -moz-transition: height 0.5s;
        -ms-transition: height 0.5s;
        -o-transition: height 0.5s;
        -webkit-transition: height 0.5s;
        transition: height 0.5s;
        overflow: hidden;
        position: relative;
      }
    }
    .hide-triangle {
      height: 0 !important;
    }
    .default-modules {
      width: 100%;
      overflow: auto;
      overflow-x: hidden;
      background-color: #ecf0f2;
      height: 35em;
      max-height: 35em;
      border: 1px solid #c9cbcd;
      border-radius: 2px;
      padding: 0.8em;
      display: flex;
      flex-direction: column;
      .list-modules {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #bebebe;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bebebe;
        border-radius: 5px;
        &:hover {
          background: #b2b2b2;
          height: 10px;
        }
      }
      .one-disposition {
        width: 192px;
        height: 117px;
      }

      @media (max-height: 575px) {
        .one-disposition {
          width: 180px;
          height: 117px;
        }
      }
      @media (max-height: 680px) and (min-height: 575px) {
        .one-disposition {
          width: 192px;
          height: 117px;
        }
      }
      @media (max-height: 850px) and (min-height: 680px) {
        .one-disposition {
          width: 192px;
          height: 117px;
        }
      }
    }
    @media (max-height: 575px) {
      .default-modules {
        max-height: 15em;
      }
    }
    @media (max-height: 680px) and (min-height: 575px) {
      .default-modules {
        max-height: 16em;
      }
    }
    @media (max-height: 850px) and (min-height: 680px) {
      .default-modules {
        max-height: 20em;
      }
    }

    @media (min-height: 850px) and (max-height: 1300px) {
      .default-modules {
        max-height: 30em;
      }
    }

    .outline-primary {
      border-color: #c9cbcd !important;
      color: #797a8e !important;
    }
    .timeline-title {
      padding: 1em 0;
    }
    .timeline-title,
    .module-title {
      display: flex;

      span {
        font-weight: 500;
        font-size: 1em;
      }
      &--size {
        font-size: 1.4em !important;
      }
    }
    .timeline-modules {
      width: 100%;
      height: 100%;
      overflow: auto;
      overflow-x: hidden;
      border-radius: 2px;
      border-top: none;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      height: 10em;
      max-height: 10em;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .div-draggable-margin {
        margin: 0 !important;
        padding: 0 !important;
      }
      #div-draggable {
        overflow-x: auto;
        overflow-y: hidden;
        margin: 0 !important;
        flex-grow: 1;
        width: 100%;
        height: 100%;
      }
      .row__inner {
        margin: 0;
        padding-bottom: 5px;
        display: flex;
        transform: translateY(4px);
        #draggable-wrapper {
          display: flex;
          flex-direction: row;
          .card-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            .counter-slides {
              padding-right: 10px;
            }
            &.extended {
              .segment-card {
                .containerScreen.tile__img {
                  &:after {
                    content: '';
                    position: absolute;
                    z-index: 2;
                    top: -4px;
                    bottom: -4px;
                    left: -4px;
                    right: -26px;
                    background: rgba(255, 255, 255, 0.8);
                  }
                }
              }
            }
            .panel-card-wrapper {
              /*height: 90px;*/
              padding-right: 0;
              position: relative;
              transition: padding-right 0.3s ease-in-out;
              &.segment-card {
                padding-right: 10px;
                .add-segment-btn {
                  visibility: hidden;
                  opacity: 0;
                  pointer-events: none;
                }
              }
              .slide {
                margin: 0px !important;
              }
              /*.tile {*/
              /*margin-left: 5px !important;*/
              /*}*/
              .add-segment-btn {
                display: none;
              }
              .panel-cards-transitions {
                display: flex;
                flex-direction: row;
              }

              &.segment-card {
                /*padding-right: 10px;*/
                padding-top: 10px;
                .add-segment-btn {
                  visibility: visible;
                  opacity: 0;
                  pointer-events: none;
                }
                .close-segment {
                  display: none;
                }
                &:hover {
                  padding-right: 0px !important;
                }
              }
              /*.add-segment-btn {*/
              /*display: none;*/
              /*}*/
            }

            .inner-slides-wrapper {
              height: 98px;
              width: 0;
              margin-bottom: -6px;
              transition: width 0.3s ease-in-out, padding 0.3s ease-in-out;
              overflow: hidden;
              position: relative;
              padding: 0;
              /*&:hover {*/
              /*.add-segment-btn {*/
              /*visibility: hidden;*/
              /*opacity: 1;*/
              /*}*/
              /*}*/
              &.extended {
                padding: 2px;
              }
              .inner-slides-container {
                transform: translateY(0) scale(0.9);
                transform-origin: left;
                display: flex;
                flex-wrap: nowrap;
                flex-direction: row;
                .slides-transitions-wrapper {
                  display: flex;
                  flex-direction: row;
                  width: 100%;
                }
              }
            }
          }
        }
      }

      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #bebebe;
        border-radius: 5px;
      }

      &::-webkit-scrollbar-thumb {
        background: #bebebe;
        border-radius: 5px;
        &:hover {
          background: #b2b2b2;
          height: 10px;
        }
      }
      .button-navigation {
        border: 1px solid #939ea7 !important;
        font-size: 32px;
        color: #939ea7;
        height: 4em;
        .icon-navigation-left {
          transform: rotate(180deg);
        }
        &--right,
        &--left {
          height: 100%;
        }
        &__left {
          position: absolute;
          float: left;
        }
        &__right {
          position: absolute;
          float: right;
          right: 0.5em;
        }
        svg {
          color: #939ea7;
          width: 1em;
        }
        &.active {
          background-color: #ffffff !important;
          color: #2196f3 !important;
          border: 2px solid #2196f3 !important;
          svg {
            background-color: #ffffff !important;
            color: #2196f3 !important;
            fill: #2196f3 !important;
            g {
              fill: #2196f3 !important;
            }
          }
        }
      }
    }

    .toggle-slides {
      display: none !important;
    }

    .search-col {
      padding: 0 !important;
      .search-group {
        display: flex;
        align-items: center;
      }
      .inputSearch {
        border-color: #7c7c7c;
        padding: 1.2rem 3rem !important;
        border-radius: 0.4rem;
        border-top-left-radius: 0.4rem !important;
        border-bottom-left-radius: 0.4rem !important;
        color: #797a8e;
        font-size: 0.9em;
        @media screen and (min-width: 992px) and (max-width: 1080px) {
          padding: 1rem 2rem !important;
        }
        @media screen and (max-width: 992px) and (min-width: 765px) {
          padding: 1rem 1.7rem !important;
        }
        @media screen and (max-width: 765px) {
          padding: 1rem 2rem !important;
        }
      }
      .close-add-screen-module {
        position: absolute;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        right: 15px;
        top: 0;
        height: 100%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        color: #797a8e;
        cursor: pointer;
        z-index: 4;
      }
      .search-icon {
        cursor: pointer;
        position: absolute;
        z-index: 7;
        display: flex;
        justify-content: center;
        padding: 0 0.5em;
        svg {
          width: 25px;
          height: 100%;
          display: flex;
          justify-content: center;
          path {
            fill: #797a8e;
          }
        }
        @media screen and (min-width: 992px) and (max-width: 1080px) {
          svg {
            width: 20px;
          }
        }
        @media screen and (max-width: 992px) and (min-width: 765px) {
          svg {
            width: 20px;
          }
        }
        @media screen and (max-width: 765px) {
          svg {
            width: 20px;
          }
        }
      }
      .search-button {
        border-right: none !important;
        background-color: #ffffff;
        color: #7c7c7c;
        border-color: #7c7c7c;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .header-module-block {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tabs-module-col {
        padding: 0 !important;
        .tabs-module {
          display: flex;
          flex-direction: row;
          justify-content: center;
          color: #797a8e;
          width: 100%;
          .tabs {
            width: 100%;
            .nav-tabs {
              margin-right: 0 !important;
              border: none !important;
              .nav-item {
                .nav-link {
                  color: #0e3243 !important;
                  font-weight: 500;
                  font-size: 1em;
                  padding: 1rem 2rem !important;
                  @media screen and (min-width: 992px) and (max-width: 1080px) {
                    padding: 1rem 1.5rem !important;
                  }
                  @media screen and (max-width: 992px) and (min-width: 765px) {
                    padding: 1rem 1rem !important;
                  }
                  @media screen and (max-width: 765px) {
                    padding: 1rem 1rem !important;
                  }
                  &.active,
                  &:active {
                    background-color: transparent !important;
                    border: none !important;
                    border-bottom: 2px solid #039be5 !important;
                    color: #039be5 !important;
                  }
                  &:hover,
                  &:focus {
                    color: #039be5 !important;
                    border: none !important;
                    border-bottom: 2px solid #039be5 !important;
                  }
                }
                &.show {
                  background-color: transparent !important;
                  border: none !important;
                  border-bottom: 2px solid rgba(26, 147, 240, 0.8) !important;
                  color: rgba(26, 147, 240, 1);
                }
              }
            }
          }
        }
      }
      @media screen and (min-width: 992px) and (max-width: 1080px) {
        font-size: 1em;
      }
      @media screen and (max-width: 992px) and (min-width: 765px) {
        font-size: 0.8em;
      }
      @media screen and (max-width: 765px) {
        font-size: 0.7em;
      }
    }
  }
}
#card-add-prog {
  background-color: #ecedf0 !important;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  margin-bottom: 5% !important;
}
#card-add-prog .card-body {
  display: flex !important;
}

.text-left {
  text-align: left;
}
.icon-add-prog {
  margin-right: 1em;
}
.lg-btn {
  width: 8em;
}

#planx {
  z-index: 99999;
  padding: 30px;
  overflow: auto;
  position: absolute;
  background-color: rgba(255, 255, 255, 1);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// AddScreen.vue?3f6c6251